module.exports = __webpack_public_path__ + "static/memory_img2@2x-da72bb518ce1f7616a05a49e8121bfb7.png";